import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcGrowthChartWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderChart();
}
